
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Operation } from '../operation/operation';
import { OperationService } from '../operation/operation.service';
import { Revision } from './revision';
import { RevisionService } from './revision.service';
import { NotifierService, DialogService } from '../ui';

@Component({
  templateUrl: './revision-list.component.html',
})
export class RevisionListComponent implements OnInit {

  operation: Operation

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private revisionService: RevisionService,
    private operationService: OperationService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    // Get the operation/revisions
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {
      this.operation = data.operation;

      this.sortRevisions();

      this.notifier.endProgress();
    });
  }

  private fetch() {
    this.notifier.startProgress();

    this.revisionService
      .revisions(this.operation.id).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        this.operation = result;

        this.sortRevisions();
      });
  }

  private sortRevisions() {
    this.operation.revisions.sort((a, b) => {
      // Compare by status
      if(a.status !== b.status) {
        if(a.status === 'DRAFT') {
          return -1;
        }
        else if(a.status === 'PRODUCTION') {
          if(b.status === 'ARCHIVE') {
            return -1;
          }
          else {
            return 1;
          }
        }
        else {
          return 1;
        }
      }
      // Compare by number
      else {
        // Int numbers
        if(a.status === 'DRAFT') {
          let aNumber = parseInt(a.number, 10);
          let bNumber = parseInt(b.number, 10);

          if(aNumber < bNumber) {
            return 1;
          }
          else if(aNumber > bNumber) {
            return -1;
          }
          else {
            return 0;
          }
        }

        // String numbers
        else {
          if(a.number < b.number) {
            return 1;
          }
          else if(a.number > b.number) {
            return -1;
          }
          else {
            return 0;
          }
        }
      }
    });
  }

  showDocuments(revision: Revision, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['operations', this.operation.id, revision.id]);
    }
  }

  add() {
    this.notifier.startProgress();

    this.revisionService
      .create(this.operation.id)
      .subscribe((revision) => {
        this.notifier.success('Révision créée avec succès');

        this.router.navigate(['operations', this.operation.id, revision.id]);

      }, (err) => {
        this.notifier.endProgress();
      });
  }

  update(revision: Revision, status: string) {

    let publish = status === 'PRODUCTION';

    this.dialogService
      .confirm({
        title: 'Révision',
        message: `Voulez-vous ${publish ? 'publier' : 'archiver'} cette révision?`,
        confirm_button_text: publish ? 'Publier' : 'Archiver',
        confirm_button_class: 'btn-primary'
      })
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.revisionService
          .update(this.operation.id, revision.id, status)
          .subscribe((revision) => {
            this.notifier.success(`Révision ${publish ? 'publiée' : 'archivée'} avec succès`);

            this.fetch();

          }, (err) => {
            this.notifier.endProgress();
          });
      });
  }

  delete(revision: Revision) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette révision?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.revisionService
          .delete(this.operation.id, revision.id)
          .subscribe((id) => {
            this.notifier.success('Révision supprimée avec succès');

            this.fetch();

          }, (err) => {
            this.notifier.endProgress();
          });
      });
  }

  deleteOperation() {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette opération?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.operationService
          .delete(this.operation.id)
          .subscribe((id) => {
            this.notifier.success('Opération supprimée avec succès');

            this.router.navigateByUrl('/operations');

          }, (err) => {
            this.notifier.endProgress();
          });
      });

    return false;
  }
}
